module.exports = __webpack_public_path__ + "img/battery_4purple.a65a2a81.png";